/* -------------------------- Design imports start -------------------------- */
/* --------------------------- Design imports end --------------------------- */

/* ------------------------ Functional imports start ------------------------ */
import React, { type ReactElement } from "react";
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import Page from '../../components/layout/Page'
/* ------------------------- Functional imports end ------------------------- */

/* -------------------------------------------------------------------------- */
/*                               Start Component                              */
/* -------------------------------------------------------------------------- */
export default function WrongRoutePage(): ReactElement {
  /* ---------------------------- Data states start --------------------------- */
  const history = useHistory()
  const { t } = useTranslation(['common'])
  /* ----------------------------- Data states end ---------------------------- */

  /* -------------------------------------------------------------------------- */
  /*                              Render Component                              */
  /* -------------------------------------------------------------------------- */
  return (
    <Page>
      Nothing here: 404
      <button id="backButton" onClick={() => history.goBack()}>
        {t('common:interaction.button.back')}
      </button>
    </Page>
  )
}
